import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { brandColors } from "../../../theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: any) => ({
      height: "100%",
      border: `2px solid ${props.status ? brandColors.success.status : brandColors.error.main}`,
      borderRadius: "5px",
      padding: theme.spacing(1.5, 2),
      color: `${props.status ? brandColors.success.status : brandColors.error.main}`,
      backgroundColor: `${props.status ? brandColors.success.bg : brandColors.secondary.bg}`,
    }),
  })
);

interface StatusProps {
  status: boolean;
  title: React.ReactNode;
  subtitle: React.ReactNode;
}

const Status: React.FC<StatusProps> = ({ status, title, subtitle }) => {
  const classes = useStyles({ status });
  return (
    <div className={classes.root}>
      <Typography variant="h4">{title}</Typography>
      <Typography variant="caption">{subtitle}</Typography>
    </div>
  );
};

export default Status;
